import {
  APP_SETTING_REMOVE_ENVIRONMENT_FROM_PROJECT_BEGIN,
  APP_SETTING_REMOVE_ENVIRONMENT_FROM_PROJECT_SUCCESS,
  APP_SETTING_REMOVE_ENVIRONMENT_FROM_PROJECT_FAILURE,
  APP_SETTING_REMOVE_ENVIRONMENT_FROM_PROJECT_DISMISS_ERROR,
} from './constants';
import axios from 'axios';
import { toast } from 'react-toastify';
import { builderSurfaceJsonContentHeader } from '../../../common/utils/restApiHeaderUtils';
import { getErrorMessageFromResponse } from '../../../common/utils/errorUtils';
import { getCookie, updateUserIpInCookie } from '../../../common/utils/api_utils';

export function removeEnvironmentFromProject(args = {}) {
  return async (dispatch) => {
    dispatch({
      type: APP_SETTING_REMOVE_ENVIRONMENT_FROM_PROJECT_BEGIN,
    });
    const { projectId, version, uuid } = args;
    const userIp = getCookie('userIp') || (await updateUserIpInCookie());
    const header = builderSurfaceJsonContentHeader(projectId, userIp);
    const promise = new Promise((resolve, reject) => {
      const doRequest = axios.delete(
        `${process.env.REACT_APP_BUILDER_ENGINE}v${version}/projects/${projectId}/environments/${uuid}`,
        header,
      );
      doRequest.then(
        (res) => {
          if (res.status === 200 && res.data) {
            dispatch({
              type: APP_SETTING_REMOVE_ENVIRONMENT_FROM_PROJECT_SUCCESS,
              data: res.data ? res.data : null,
            });
            toast.success('Deleted Successfully !', {});
            resolve(res);
          } else {
            dispatch({
              type: APP_SETTING_REMOVE_ENVIRONMENT_FROM_PROJECT_FAILURE,
              data: { error: 'Failed' },
            });
            const errMsg = getErrorMessageFromResponse(res);
            toast.error(`Failed: ${errMsg}`, {});
            reject('Failed');
          }
        },
        (err) => {
          dispatch({
            type: APP_SETTING_REMOVE_ENVIRONMENT_FROM_PROJECT_FAILURE,
            data: { error: err },
          });
          const errMsg = getErrorMessageFromResponse(err.response);
          toast.error(`Failed: ${errMsg}`, {});
          reject(err);
        },
      );
    });

    return promise;
  };
}

export function dismissRemoveEnvironmentFromProjectError() {
  return {
    type: APP_SETTING_REMOVE_ENVIRONMENT_FROM_PROJECT_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case APP_SETTING_REMOVE_ENVIRONMENT_FROM_PROJECT_BEGIN:
      return {
        ...state,
        removeEnvironmentFromProjectPending: true,
        removeEnvironmentFromProjectError: null,
      };

    case APP_SETTING_REMOVE_ENVIRONMENT_FROM_PROJECT_SUCCESS:
      return {
        ...state,
        removeEnvironmentFromProjectPending: false,
        removeEnvironmentFromProjectError: null,
        projectDetail: action.data ? action.data : state.projectDetail,
      };

    case APP_SETTING_REMOVE_ENVIRONMENT_FROM_PROJECT_FAILURE:
      return {
        ...state,
        removeEnvironmentFromProjectPending: false,
        removeEnvironmentFromProjectError: action.data.error,
      };

    case APP_SETTING_REMOVE_ENVIRONMENT_FROM_PROJECT_DISMISS_ERROR:
      return {
        ...state,
        removeEnvironmentFromProjectError: null,
      };

    default:
      return state;
  }
}
